<script lang="ts" setup>
import { GpTextInput } from '@gportal/uikit';
import { useProjectStore } from 'gpcore-apikit/store/pinia/project';
import type { InviteMemberToProjectResponse } from 'gpcore-grpc/gpcore/api/cloud/v1/responses_pb';
import AsyncModal from 'gpcore-uikit/components/new/AsyncModal.vue';
import { computed, ref } from 'vue';

defineProps<{ show: boolean }>();

const emit = defineEmits<{ (e: 'close'); (e: 'confirm') }>();

const projectStore = useProjectStore();

const identifiers = ref('');

const hasIdentifiers = computed(() => identifiers.value.trim().length > 0);
const invite = () => {
  if (!hasIdentifiers.value) {
    return undefined;
  }

  const promises = new Array<Promise<InviteMemberToProjectResponse>>();
  identifiers.value.split(',').forEach((identifier: string) => {
    if (identifier.trim().length > 0) {
      promises.push(projectStore.inviteMember(identifier.trim()));
    }
  });

  return Promise.all(promises);
};

const onDone = () => {
  emit('close');
};
</script>

<template>
  <AsyncModal
    :show="show"
    :header-icon="['fas', 'fa-users']"
    header-text="Invite your team members"
    :async-function="invite"
    confirm-text="Invite"
    :is-valid="hasIdentifiers"
    @close="$emit('close')"
    @done="onDone"
  >
    <template #content>
      <div class="tw-mb-8 tw-px-4">
        <p class="tw-mb-4">
          Enter multiple e-mail addresses of existing users to add them to the project. Once added,
          they need to confirm the invite to join the project.
        </p>
        <GpTextInput
          placeholder="user1@example.com, user2@example.com, user3@example.com"
          input-id="invite-emails"
          name="e-mails"
          :required="true"
          label=""
          v-model="identifiers"
        />
      </div>
    </template>
  </AsyncModal>
</template>
